import "./ClaimsAndForms.css";

function ClaimsAndForms(): JSX.Element {
    return (
        <div className="ClaimsAndForms">
            claims and accident forms
        </div>
    );
}

export default ClaimsAndForms;
